import React from 'react';

import RequestQueueTablePage from './RequestQueueTablePage';
import { waitingActsFallbackQueue } from './requestQueueFallbacks';


export default function WaitingActsPage() {
    return (
        <RequestQueueTablePage
            title="Ожидание актов"
            queueName="waiting_acts"
            summaryLabel="Заявок без акта"
            emptyQueueText="Сейчас нет заявок в ожидании актов."
            warningText="Не удалось загрузить заявки. Показан локальный пример."
            fallbackQueue={waitingActsFallbackQueue}
            detailPathPrefix="/app/acts/waiting"
        />
    );
}
